import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from '../../../services/data/data.service';
import { SelectTitleComponent } from '../../../components/select-title/select-title.component';
import { firstValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import { CuentaContableService } from '../../../services/proyecciones/cuenta-contable/cuenta-contable.service';
import { InstitucionService } from '../../../services/proyecciones/institucion/institucion.service';
import { SucursalService } from '../../../services/proyecciones/sucursal/sucursal.service';
import Swal from 'sweetalert2';
import { PeriodosSaldosService } from '../../../services/proyecciones/periodos-saldos/periodos-saldos.service';
import { FiltersM } from '../../../components/models';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'MMM YY',
  },
  display: {
    dateInput: 'MMM YY',       // ← "ene 26"
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-proyecciones',
  templateUrl: './proyecciones.component.html',
  styleUrl: './proyecciones.component.css',
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es' },
  ]
})

export class ProyeccionesComponent {
  public metodosProyeccion = [];

  public cuentas = [];
  public Filters = FiltersM;
  @ViewChild(SelectTitleComponent) titleSelect!: SelectTitleComponent;
  public plantilla;
  public instSelecc: any = {id: 0, alias: ''};
  private  templateId = undefined;
  private institucionId = undefined;
  public inst = [];
  private dataContable = [];
  public dataSucursales = [];
  public sucursalSelect;
  public periodoSelec = { name: ``, anio: '', nmes: -1};

  public consolidado: boolean = true;
  public sucursalSeleccionada: string = 'Consolidado';
  public sinSaldo:boolean = false;
  public dataCuentaContable: any[] = [];
  public cuentasJerarquicas: any[] = [];
  public cuentasVisibles: any[] = [];
  public columnasFechas: string[] = [];
  public selectedProjectionYear: number | undefined;
  public graficaUrl = 'assets/img/proyecciones-grafica.png';
  public cuentaSelec = undefined;

  public modalOpen = false;

  public formEscenario = new FormGroup({
    nombre: new FormControl('', [Validators.required]),
    tipo: new FormControl('', [Validators.required]),
    fechaIni: new FormControl(null, [Validators.required]),
    fechaFin: new FormControl(null, [Validators.required]),
    descripcion: new FormControl('', [Validators.required]),
    fechaElaboracion: new FormControl(null, [Validators.required])
  })
  constructor(
    public cookies: CookieService,
    public dataService: DataService,
    private translate: TranslateService,
    private cuentaContable: CuentaContableService,
    private instituciones: InstitucionService,
    private sucursales: SucursalService,
    private periodoSaldo: PeriodosSaldosService,
    private _adapter: DateAdapter<Date>
  ){
    this.templateId = Number(cookies.get('templateId'));
    this.institucionId = cookies.get('idInstitucionProy');
    this.getInstituciones();
  }
  public async getInstituciones(){//lista todas las instituciones con una platilla activa
    try{
      const res = await firstValueFrom(this.instituciones.getInstucionesTemplateActivo());
      this.inst = res;
      const instId = this.dataService.idInstitution;
      if(this.institucionId){
        this.instSelecc = this.inst.filter(i => i.institutionid == this.institucionId)[0];
        await this.getSucursales();
        this.getPeriodosSucursal();
        this.getSucursales();
        this.getMetodosProyeccion();
        this.getCuentasContables();
        return;
      }
      this.selectInst();
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }
  private async getSucursales() {
    try{
      const res = await firstValueFrom(this.sucursales.getSucursales(this.institucionId));
      const s = new Set();
      this.dataSucursales = res.map(({ nombre, ...rest}) => ({
        name: nombre,
        ...rest,
      })).filter( i => {
        if(s.has(i.name))
          return false;
        s.add(i.name);
        return true;
      });
      this.sucursalSelect = this.dataSucursales.find(i=>i.consolidado);
    }catch(e){
      messages.errorMessageGraph(e.error);
    }

    this.sucursalSeleccionada = 'filtros.consolidado';
  }
  private getMetodosProyeccion(){
    //TODO aqui se hara la consulta para obtener la lista de metodos de proyeccion para seleccionar
    this.metodosProyeccion = [
    { valor: 'regresion1', label: 'Regresión lineal 1' },
    { valor: 'regresion2', label: 'Regresión lineal 2' },
    { valor: 'regresion3', label: 'Regresión lineal 5' },
    { valor: 'regresion4', label: 'Prom móvil simple 1' },
    { valor: 'regresion5', label: 'Prom móvil simple 12' },
    { valor: 'regresion6', label: 'Prom móvil simple 21' },
  ]
  }
  private async getCuentasContables() { 
    try{
      const res = await firstValueFrom(this.cuentaContable.getCuentas(this.instSelecc.templates[0].templateid));
      this.dataContable = res.map(d => ({
        codigo: d.codigo,
        nombre: d.nombre,
        saldo: this.generarCantidadAleatoria(),
        metodo: 0,
        valido: true,
      }));
      this.cuentas = [...this.dataContable];
      this.cuentaSelec = this.cuentas[0];
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }
  public async selectInst(){
    const instId = this.dataService.idInstitution;
    const role = this.dataService.role.toLowerCase();
    const insti = this.inst
      .filter( i => i.alias !== null)
      .reduce((i, item) => {
      i[item.institutionid] = item.alias;
      return i;
    }, {})
    if(role.includes('administrador')){
      const result = await messages.select(
        this.translate.instant('Seleccione una institución'),
        insti,
        this.translate
      );
      if(result){
        this.instSelecc = this.inst.filter(i => i.institutionid == result)[0];
        this.cookies.set('idInstitucionProy',this.instSelecc.institutionid, {path: '/'});
        this.institucionId = this.instSelecc.institutionid;
        this.getCuentasContables();
        await this.getSucursales();
        this.getPeriodosSucursal();
      }
    }else{
      // TODO falta validar el funcionamiento con un usuario que no sea admi
      try{
        const res = await firstValueFrom(this.instituciones.getInstitucionIdAdmi(instId));
        this.instSelecc = this.inst.find(i => i.institutionid == res?.[0]?.id) ?? null;
        if(this.instSelecc){
          this.cookies.set('idInstitucionProy',this.instSelecc.institutionid, {path: '/'});
          this.institucionId = this.instSelecc.institutionid;
          this.getCuentasContables();
          await this.getSucursales();
          this.getPeriodosSucursal();
        }else{
          messages.infoMessageGraph(this.translate.instant('proyFinanciera.cargaInformacion.noPlantilla'))
        }
      }catch(e){
        messages.errorMessageGraph(e.error);
      }
    }
  }
  private async getPeriodosSucursal(){
    try{
      const res = await firstValueFrom(this.periodoSaldo.getPeriodosSucursal(this.institucionId, this.sucursalSelect.sucursalid));
      const meses = [
        'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
      ];

      const anios = Object.keys(res).sort((a, b) => Number(a) - Number(b));
      const ultimoAnio = anios[anios.length - 1];

      if (!ultimoAnio) return null;

      const periodos = res[ultimoAnio];
      const ultimoPeriodo = periodos[periodos.length - 1];

      const mes = meses[ultimoPeriodo - 1];

      const perSelec = { name: `${mes} ${ultimoAnio}`, anio: ultimoAnio, nmes: ultimoPeriodo};
      this.periodoSelec = perSelec;
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }
  public async sucursalChange(sucClick: any) {
    for (const suc of this.dataSucursales) {
      if (sucClick !== 'consolidado' && suc.name === sucClick.name) {
        suc.check = true;
      } else {
        suc.check = false;
      }
    }

    if (sucClick === 'consolidado') {
      this.consolidado = !this.consolidado;
      this.sucursalSeleccionada = 'filtros.consolidado';
    } else {
      this.consolidado = false;
      this.sucursalSeleccionada = sucClick.name;
    }
    // Si no hay cuentas cargadas, intentar obtenerlas; si ya están, regenerar valores aleatorios
    if (!this.dataCuentaContable || this.dataCuentaContable.length === 0) {
      if (this.templateId) {
        // carga asíncrona de cuentas (mantendrá el skeleton si no hay datos)
        await this.getCuentasContables();
      }
    }
  }
  private generarCantidadAleatoria(): string {
    const numero = Math.floor(Math.random() * 99000000) + 1000000;
    return numero.toLocaleString('es-MX');
  }
  public cambiarImagen(item){
    this.cuentaSelec = item;
  }
  public guardarConfiguracion(){
    //validar que todas las cuentas esten validadas
    if(this.cuentas.some(i => !i.valido)){
      messages.infoMessageGraph(this.translate.instant('proyFinanciera.proyecciones.noValidado'));
    }else{
      this.modalOpen = true;
    }    
  }
  public closeModal(){
    this.modalOpen = false;
  }
  public guardarEscenario(){

  }
  public setFecha(event: Date, datepicker: any, fechaid: string) {
    const normalizado = this._adapter.createDate(
      event.getFullYear(),
      event.getMonth(),
      1
    );
    this.formEscenario.get(fechaid)?.setValue(normalizado);
    datepicker.close();
  }
  public filtroSinSaldo(){
    this.cuentas = [];
    this.sinSaldo = !this.sinSaldo;
    if(this.sinSaldo){ //se quitan las cuentas que tienen saldo en cero 
      this.cuentas = this.dataContable.filter(d => d.saldo !== 0);
    }else{// se muestran todas las cuentas
      this.cuentas = [...this.dataContable];
    }
  }
}

